import React, { useMemo } from 'react';
import { faRefresh, faDownload, faPrint } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import ActionToolbar from '../common/ActionToolbar';
import { UI_COLORS } from '../../utils/colors';

const DeliveryChallanActions = ({
    showSearch = true,
    searchValue = '',
    onSearchChange,
    onRefresh,
    refreshLoading = false,
    onPrint,
    printLoading = false,
    statusValue = '',
    onStatusChange,
    fromDate = '',
    toDate = '',
    onFromDateChange,
    onToDateChange,
    onExport,
    exportLoading = false,
    canExport = false,
}) => {
    const { t } = useTranslation();
    const actions = useMemo(() => {
        const list = [];
        if (onPrint) {
            list.push({
                key: 'print-table',
                label: t('commonCols.print'),
                icon: faPrint,
                onClick: onPrint,
                disabled: printLoading,
                variant: 'ghost',
                showLabelBreakpoint: 'sm',
                spinner: printLoading,
            });
        }
        if (canExport) {
            list.push({
                key: 'export-challans',
                label: t('commonCols.export'),
                icon: faDownload,
                onClick: onExport,
                disabled: exportLoading,
                variant: 'success',
                showLabelBreakpoint: 'sm',
                spinner: exportLoading,
            });
        }
        list.push({
            key: 'refresh-challans',
            label: t('deliveryChallanModule.actions.refresh'),
            icon: faRefresh,
            onClick: onRefresh,
            disabled: refreshLoading,
            variant: 'ghost',
            showLabelBreakpoint: 'sm',
            spinner: refreshLoading,
        });
        return list;
    }, [canExport, onRefresh, refreshLoading, onExport, exportLoading, onPrint, printLoading, t]);

    const statusOptions = useMemo(() => ([
        { value: '', label: t('deliveryChallanModule.actions.filters.all') },
        { value: 'in_transit', label: t('deliveryChallanModule.actions.status.in_transit') },
        { value: 'delivered', label: t('deliveryChallanModule.actions.status.delivered') },
    ]), [t]);

    const filters = useMemo(() => {
        const dateInputStyle = {
            backgroundColor: UI_COLORS.FORMS.INPUT.background,
            borderColor: UI_COLORS.FORMS.INPUT.border,
            color: UI_COLORS.TEXT.BLACK || UI_COLORS.FORMS.INPUT.text,
        };
        return [
            {
                key: 'status-filter',
                type: 'select',
                label: t('deliveryChallanModule.actions.filters.status'),
                value: statusValue,
                options: statusOptions,
                onChange: onStatusChange,
            },
            <div key="from-date" className="flex-shrink-0 flex items-center gap-2">
                <label className="text-sm" style={{ color: UI_COLORS.FORMS.LABEL }}>From</label>
                <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => onFromDateChange && onFromDateChange(e.target.value)}
                    className="px-3 py-2 rounded-xl border-2"
                    style={dateInputStyle}
                />
            </div>,
            <div key="to-date" className="flex-shrink-0 flex items-center gap-2">
                <label className="text-sm" style={{ color: UI_COLORS.FORMS.LABEL }}>To</label>
                <input
                    type="date"
                    value={toDate}
                    onChange={(e) => onToDateChange && onToDateChange(e.target.value)}
                    className="px-3 py-2 rounded-xl border-2"
                    style={dateInputStyle}
                />
            </div>,
        ];
    }, [statusValue, onStatusChange, statusOptions, fromDate, toDate, onFromDateChange, onToDateChange, t]);

    return (
        <ActionToolbar
            showSearch={showSearch}
            searchValue={searchValue}
            onSearchChange={onSearchChange}
            searchPlaceholder={t('deliveryChallanModule.actions.searchPlaceholder')}
            filters={filters}
            actions={actions}
        />
    );
};

export default DeliveryChallanActions;
